/** Statuses for reporting */
const ACTIVE_VERSION_STATUS = 'Active';
const ARCHIVED_VERSION_STATUS = 'Inactive';

/** Millisecond delay between last typed character and searching */
const SEARCH_TYPING_DELAY_MILLISECONDS = 300;

const REVIEW_STATUSES = [
	{ 'label': 'Not Reviewed', 'value': null },
	{ 'label': 'In Review', 'value': 4 },
	{ 'label': 'Conditional Approval', 'value': 0 },
	{ 'label': 'Manual Approval', 'value': 1 },
	{ 'label': 'Not Applicable', 'value': 2 },
	{ 'label': 'Denial', 'value': 3 },
];

const REVIEW_STATES = [
	'In Review',
	'Not Started',
	'Denied',
	'In Progress',
	'Accepted'
];

const DEPARTMENT_REVIEW_STATES = [
	'Not Reviewed',
	'Reviewed',
];

export default {
  ACTIVE_VERSION_STATUS,
  ARCHIVED_VERSION_STATUS,
  SEARCH_TYPING_DELAY_MILLISECONDS,
  REVIEW_STATUSES,
  REVIEW_STATES,
  DEPARTMENT_REVIEW_STATES
};
